import i18n from "../../language/i18n";
import MobileAppHandoffCard from "./MobileAppHandoffCard";
import {
  SsoMobileAppHandoff,
  storeUrlFor,
} from "../../utilization/MobileAppHandoffUtilization";

interface SsoMobileAppHandoffCardProps {
  handoff: SsoMobileAppHandoff;
}

// The SEBIT / external-client phone card. Android has an app URL carrying the sign-in, so it offers "open the app"
// as well as the store; iOS has nothing it may hand over (see `buildSsoMobileAppHandoff`), so it offers the store and
// tells the learner to come back through the platform they started from once the app is installed.
const SsoMobileAppHandoffCard = ({ handoff }: SsoMobileAppHandoffCardProps) => {
  const { platform, appUrl } = handoff;
  return (
    <MobileAppHandoffCard
      title={i18n.t("sso_mobile_app_title")}
      description={i18n.t(
        appUrl ? "sso_mobile_app_description" : "sso_mobile_app_description_reopen"
      )}
      primaryAction={
        appUrl
          ? {
              title: i18n.t("mobile_app_open"),
              onClick: () => {
                window.location.href = appUrl;
              },
            }
          : undefined
      }
      secondaryAction={{
        title: i18n.t(
          platform === "ios"
            ? "mobile_app_download_ios"
            : "mobile_app_download_android"
        ),
        onClick: () => {
          window.location.href = storeUrlFor(platform);
        },
      }}
    />
  );
};

export default SsoMobileAppHandoffCard;
